<template>
  <button
    class="btn-nav"
    @click="$store.dispatch('showNext', {n:loc, el:'#'+link})"
    :class="{disabled: $store.state.currentLocation >= loc}"
    :disabled="$store.state.currentLocation >= loc"
  >
    <slot>Understood</slot>
  </button>
</template>

<script>
export default {
  props: {
    loc: Number,
    link: String,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
/*------------------------------------*\
  #PRIMARY COLOURS
\*------------------------------------*/
@import '../styles/colors';

/*------------------------------------*\
  #Mixins
\*------------------------------------*/

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/
/**
* General Button Styling
*/

/**
* General Button Styling
*/
.btn-nav {
  color: $dark-grey;
  border: 2px solid $dark-grey;
  // border-radius: 25px;
  background: transparent;
  padding: 10px 30px;
  margin: 2rem auto 1rem;
  display: block;
  width: auto;
  min-width: 150px;

  &:focus {
    background: $dark-grey;
    color: #fff;
  }
  &:hover {
    background: $dark-grey;
    color: #fff;
    border: 2px solid $dark-grey
  }

  /**
  * Modifiers
  */
  &--white {
    color: #fff;
    border-color: #fff;
    background: transparent;

    &:focus {
      background: #fff;
      color: $dark-grey;
    }
    &:hover {
      background: #fff;
      color: $dark-grey;
    }
  }

  &--red {
    color: $dark-red;
    border-color: $dark-red;
    background: transparent;

    &:focus {
      background: #fff;
      color: $dark-red;
    }
    &:hover {
      background: $dark-red;
      color: #fff;
      border: 2px solid $dark-red;
    }
  }

  &--orange {
    color: $orange;
    border-color: $orange;
    background: transparent;

    &:focus {
      background: #fff;
      color: $orange;
    }
    &:hover {
      background: $orange;
      color: #fff;
      border: 2px solid $orange;
    }
  }
}

.disabled {
  opacity: 0.3;
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
